import { useMemberActions } from '@poplar/contexts/MemberActionsProvider';
import { ChecklistCardIcon } from '@yoweb/ui/components/Icon/ChecklistCardIcon';
import { ChecklistCardFilledIcon } from '@yoweb/ui/components/Icon/ChecklistCardFilledIcon';
import { NavIconActivityDot, NavIconActivityDotContainer } from '@poplar/components/NavGlobal/NavIconActivityDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TodosIcon = function TodosIcon(_ref) {
  var isActive = _ref.isActive,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size;

  var _useMemberActions = useMemberActions(),
      actionItems = _useMemberActions.state.actionItems;

  return /*#__PURE__*/_jsxs(NavIconActivityDotContainer, {
    "data-testid": "todos-notification",
    children: [actionItems && actionItems.length > 0 && /*#__PURE__*/_jsx(NavIconActivityDot, {
      color: "critical",
      borderColor: "sandLight",
      "data-testid": "todos-notification-dot",
      border: true
    }), isActive ? /*#__PURE__*/_jsx(ChecklistCardFilledIcon, {
      size: size
    }) : /*#__PURE__*/_jsx(ChecklistCardIcon, {
      size: size
    })]
  });
};